import React from "react";
import Link from "next/link";
import BlogEntryTeaser from "components/blog/blogentryteaser";
import Styles from "./global.scss";

const Recommended = ({ whatIsPosts, recommendedPosts }) => {
    const styles = Styles;
    return (
        <section className="recommended">
            <style jsx>{styles}</style>
            <div className="recommended__row">
                {/* Left */}

                <div className="recommended__column">
                    <h4 className="title-small">Aanraders</h4>

                    {/* 1 */}

                    {recommendedPosts?.map((p) => (
                        <BlogEntryTeaser layout="thumbnail" key={p.id} post={p} />
                    ))}

                    <div className="recommended__cta">
                        <a href="/blog/aanraders">Bekijk alle aanraders»</a>
                    </div>
                </div>

                {/* Right */}

                <div className="recommended__column">
                    <h4 className="title-small">Wat is…</h4>

                    {/* 1 */}
                    {whatIsPosts?.map((p) => (
                        <BlogEntryTeaser layout="thumbnail" key={p.id} post={p} />
                    ))}

                    <div className="recommended__cta">
                        <a href="/blog/wat-is">Bekijk alle artikelen »</a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Recommended;
